import _ from "lodash"

import { OptionListId } from "shared/hubrise/ids"
import * as OptionList from "shared/hubrise/utils/OptionList"

import { IOptionList, IOption } from "../models"

import type { Change, OperationContext } from "./types"

export type OptionListOperations = {
  add(insertAfter: IOptionList | undefined, values: Partial<IOptionList>, optionValues?: Partial<IOption>): IOptionList
  delete(id: OptionListId): void
  move(optionList: IOptionList, newPosition: number): void
  reorderOptions(id: OptionListId, options: Array<IOption>): void
  update<T extends keyof IOptionList>(
    id: OptionListId,
    fieldName: T,
    value: IOptionList[T],
    options?: { collapse?: boolean },
  ): void
}

export default ({ catalog, pushState }: OperationContext): OptionListOperations => ({
  add(insertAfter, values, optionValues) {
    const { newCatalog, optionList } = OptionList.add(catalog, insertAfter, values, optionValues)
    pushState(newCatalog, { model: "optionList", operation: "add" })
    return optionList
  },

  delete(id) {
    const newCatalog = OptionList.doDelete(catalog, id)
    pushState(newCatalog, { model: "optionList", operation: "delete", id })
  },

  move(optionList, newPosition) {
    const newCatalog = OptionList.move(catalog, optionList, newPosition)
    const change: Change = { model: "optionList", operation: "move", id: optionList.id }
    pushState(newCatalog, change, (previousChange) => _.isEqual(previousChange, change))
  },

  reorderOptions(id, options) {
    const newCatalog = OptionList.update(catalog, id, "options", options)
    const change: Change = {
      model: "optionList",
      id,
      operation: "reorderOptions",
    }
    pushState(newCatalog, change, (previousChange) => _.isEqual(previousChange, change))
  },

  update(id, fieldName, value, { collapse = true } = {}) {
    const newCatalog = OptionList.update(catalog, id, fieldName, value)
    const change: Change = {
      model: "optionList",
      id,
      operation: "update",
      fieldName,
    }
    pushState(newCatalog, change, (previousChange) => collapse && _.isEqual(previousChange, change))
  },
})
